<template>
  <div>
    <b-modal
      :id="'multipleKioskSettings_' + data.id"
      hide-footer
      hide-header
      size="lg"
      scrollable
    >
      <UpdatekiosksMultiple
        :entity="data"
        :modalId="'multipleKioskSettings_' + data.id"
        @updateKioskSettings="updateKioskSettings"
      />
    </b-modal>

    <b-modal
      :id="'addAreaFromSite_' + data.id + 'ConfirmModal'"
      hide-footer
      hide-header
      size="md"
      scrollable
    >
      <AddEditAreaFromSite
        :modal_id="'addAreaFromSite_' + data.id + 'ConfirmModal'"
        :site="{ id: data.id, name: data.name }"
        @createArea="createArea"
        @updateArea="updateArea"
      />
    </b-modal>

    <b-modal
      :id="'moveArea_' + data.id"
      scrollable
      hide-footer
      hide-header
      size="lg"
    >
      <MoveArea @moveArea="moveArea" />
    </b-modal>

    <b-modal
      :id="'addKiosk_' + data.id"
      scrollable
      hide-footer
      hide-header
      size="lg"
    >
      <AddKiosk
        :loading="loading"
        :showSite="true"
        :parentArea="data"
        @addKiosk="addKiosk"
      />
    </b-modal>

    <DxDropDownButton
      v-if="types.includes(type)"
      :items="items"
      :drop-down-options="{ width: 133, maxHeight: 179 }"
      :scrollable="true"
      :text="type == 'site' ? $t('sitesAndDevices.siteActions.action') : type == 'area' ? $t('sitesAndDevices.areaActions.action'): $t('sitesAndDevices.kioskActions.action')"
      :disabled="
        getPackageType == 'Standalone' &&
        (type == 'kiosk' || type == 'site') &&
        userEmail != 'lt_techteam@visipoint.com'
      "
      class="selectActions"
      itemTemplate="actionsTemp"
    >
      <template #actionsTemp="{ data }">
        <template v-if="type == 'kiosk'">
          <div
            class="dropdown-wrapper"
            id="new-dropdown"
            title=""
            v-b-modal="data.modalId ? data.modalId : null"
            @click="
              data.actionType == 'restart_kiosk' ||
              data.actionType == 'restart_app' ||
              data.actionType == 'open_door'
                ? setActions(data)
                : data.id == 'manual_pull_database'
                ? pullDatabase(kioskInfo)
                : data.text == 'Screenshot'
                ? remoteShowScreen(kioskInfo)
                : data.text == 'Get Logs'
                ? kioskLogging(kioskInfo) 
                : data.action == 'delete'
                ? setDeleteModalData({
                    name:
                      data.name.charAt(0).toUpperCase() + data.name.slice(1),
                    id: data.id,
                    type: 'kiosk',
                  })
                : setActionData(data)
            "
          >
            <div
              class="dropdown-items"
              title=""
              :class="{ 'red-remove': data.action == 'delete' }"
            >
              {{ data.text }}
            </div>
          </div>
        </template>

        <template v-else>
          <div
            :class="{ 'bold-divider': data.isBold }"
            class="dropdown-wrapper"
            id="new-dropdown"
            title=""
            v-b-modal="data.modalId ?? null"
            @click="
              data.action == 'delete'
                ? setDeleteModalData({
                    name:
                      data.name.charAt(0).toUpperCase() + data.name.slice(1),
                    id: data.id,
                    type: data.type,
                  })
                : data.action == 'download_exe'
                ? generateAndDownloadAreaExeFileEvent(data.areaInfo)
                : data.action == 'setData'
                ? setData({})
                : setActionData(data)
            "
          >
            <div
              class="dropdown-items"
              title=""
              :class="{ 'red-remove': data.action == 'delete' }"
            >
              {{ data.text }}
            </div>
          </div>
        </template>
      </template>
    </DxDropDownButton>

    <!-- Kiosk actions modal -->
    <b-modal
      :id="'kioskActions' + kioskInfo.mac_address"
      size="md"
      hide-footer
      hide-header
    >
      <KioskActionsModal :actionType="kioskActionType" :kioskInfo="kioskInfo" />
    </b-modal>

    <b-modal
      :id="'kioskSetting_' + data.id"
      scrollable
      hide-footer
      hide-header
      size="lg"
    >
      <KioskSetting
        :modal_id="'kioskSetting_' + data.id"
        @kioskUpdated="kioskUpdated"
      />
    </b-modal>

    <b-modal :id="'installApp_' + data.id" hide-footer hide-header size="md">
      <UpdateApp />
    </b-modal>

    <b-modal
      :id="'refreshFaceLibrary_' + data.id"
      hide-footer
      hide-header
      size="md"
    >
      <RefreshFaceLibrary :data="data" />
    </b-modal>

    <b-modal
      :id="'moveKiosk_' + data.id"
      scrollable
      hide-footer
      hide-header
      size="lg"
    >
    <MoveKiosk
        @moveMultipleKiosks="moveMultipleKiosks"
        @moveSingleKiosk="moveSingleKiosk"
      />
    </b-modal>

    <b-modal :id="'changeJourney_' + data.id" hide-footer hide-header size="md">
      <ChangeJourney
        @changeKioskJourney="changeKioskJourney"
      />
    </b-modal>

    <b-modal
      :id="'kioskLogs_' + data.id"
      hide-footer
      hide-header
      size="lg"
      scrollable
    >
      <KioskDaemonLogs :kiosk_mac_address="data.mac_address" :id="data.id" />
    </b-modal>

    <b-modal
      :id="'kioskInfo_' + data.id"
      hide-footer
      scrollable
      hide-header
      size="md"
    >
      <KioskInfo :kiosk_id="data.id" />
    </b-modal>

    <b-modal
      :id="'remoteControl_' + data.id"
      hide-footer
      scrollable
      hide-header
      size="lg"
    >
      <KioskRemoteControl :kiosk_id="data.id" :kioskInfo="kioskInfo" />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MoveArea from "@/components/sites/MoveAreaForTreeList";
import UpdatekiosksMultiple from "@/components/sites/UpdatekiosksMultiple";
import AddKiosk from "@/components/sites/AddKioskForTreeList";
import KioskInfo from "@/components/sites/KioskInfo";
import KioskDaemonLogs from "@/components/sites/KioskDaemonLogsForTreelist";
import ChangeJourney from "@/components/sites/ChangeJourneyForTreeList";
import MoveKiosk from "@/components/sites/MoveKiosk";
import RefreshFaceLibrary from "@/components/sites/RefreshFaceLibrary";
import AddEditAreaFromSite from "@/components/sites/AddEditAreaFromSiteForTreeList";
import KioskSetting from "@/components/sites/UpdateKiosk";
import KioskRemoteControl from "@/components/sites/KioskRemoteControl";
import UpdateApp from "@/components/sites/UpdateApp";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import KioskActionsModal from "./KioskActionsModal.vue";
import { areaModes } from "@/utils/Constants";

export default {
  components: {
    UpdatekiosksMultiple,
    MoveArea,
    AddKiosk,
    KioskInfo,
    KioskDaemonLogs,
    ChangeJourney,
    MoveKiosk,
    RefreshFaceLibrary,
    AddEditAreaFromSite,
    KioskSetting,
    UpdateApp,
    DxDropDownButton,
    KioskActionsModal,
    KioskRemoteControl,
  },
  props: ["data", "type", "multi", "loading"],
  data() {
    return {
      kioskInfo: {},
      kioskActionType: "",
      items: [],
      types: ["site", "area", "kiosk"],
    };
  },
  computed: {
    ...mapGetters("authfack", ["currentEntity"]),
    ...mapGetters("authfack", ["userDetails"]),
    getPackageType() {
      const { currentEntity } = this;
      return currentEntity && currentEntity.package;
    },
    userEmail() {
      return this.userDetails && this.userDetails.email;
    },
    areaModes() {
      return areaModes;
    },
  },
  methods: {
    ...mapActions("modal", ["setData"]),
    ...mapActions("sites", ["downloadAreaExeFile"]),
    ...mapActions("daemon", [
      "updateApp",
      "remoteShowScreen",
      "kioskLogging",
      "forceResyncWithLogs",
      "pullDatabase",
    ]),
    kioskUpdated() {
      this.$emit("kioskUpdated", `kioskSetting_${this.data.id}`);
    },
    changeKioskJourney(kioskData, modalId) {
      this.$emit("changeKioskJourney", kioskData, modalId);
    },
    moveMultipleKiosks(kioskData, modalId) {
      this.$emit("moveMultipleKiosks", kioskData, modalId);
    },
    moveSingleKiosk(kioskData, modalId) {
      this.$emit("moveSingleKiosk", kioskData, modalId);
    },
    addKiosk(kioskData, modalId) {
      this.$emit("addKiosk", kioskData, modalId);
    },
    moveArea(areaData, modalId) {
      this.$emit("moveArea", areaData, modalId);
    },
    updateKioskSettings(kioskData, modalId) {
      this.$emit("updateKioskSettings", kioskData, modalId);
    },
    updateArea(areaData) {
      this.$emit("updateArea", areaData);
    },
    createArea(areaData, modalId) {
      this.$emit("createArea", areaData, modalId);
    },
    setActions(data) {
      this.setData({
        kioskInfo:{
          name:data.name,
          mac_address:data.mac_address
        },
        actionType:data.actionType
      });
      this.$bvModal.show("kioskActions" + data.mac_address);
    },
    setActionData(itemData) {
      console.log('itemData',itemData);
      Object.assign(this.data, { 
        isEditArea :itemData?.isEditMode ,
        areaMode:itemData?.areaMode,
        modalId: itemData.modalId
      });
      this.setData(this.data);
    },
    setDeleteModalData(data) {
      this.setData(data);

      switch (data.type) {
        case "site":
          this.$bvModal.show("deleteSite");
          break;
        case "area":
          this.$bvModal.show("deleteArea");
          break;
        case "kiosk":
          this.$bvModal.show("deleteKiosk");
          break;
      }
    },
    updateState() {
      this.$store.dispatch("sites/fetchSitesWithAreasAndKiosks");
    },
    generateAndDownloadAreaExeFileEvent(area) {
      this.$emit("generateAndDownloadAreaExeFileEvent", area);
    },
    deleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          this.type == "kiosk"
            ? `De-registering a kiosk will delete all stored data in Kiosk ${this.data.name} ?`
            : `Are you sure you want to delete this ${this.data.name}? ${this.$t('sitesAndDevices.notes.onAreaDelete')}`,
          {
            id: "deleteModal_",
            title: "Confirmation",
            size: "md",
            buttonSize: "md",
            okVariant: "primary",
            cancelVariant: "outline-secondary",
            okTitle: "Confirm",
            headerClass: "border-bottom-0 h1",
            footerClass: "p-2 border-top-0",
            centered: true,
          }
        )
        .then((proceed) => {
          // let isDeleted = false;
          if (proceed) {
            const { id } = this.data;
            switch (this.type) {
              case "site":
                this.deleteSite(id).then(() => {
                  this.$store.dispatch("sites/fetchSitesWithAreasAndKiosks");
                });
                // isDeleted = true;
                break;
              case "kiosk":
                this.deleteKiosk(this.data.id).then(() => {
                  this.$store.dispatch("sites/fetchSitesWithAreasAndKiosks");
                });
                // isDeleted = true;
                break;
              case "area":
                this.deleteArea(this.data.id).then(() => {
                  this.$store.dispatch("sites/fetchSitesWithAreasAndKiosks");
                });
                // isDeleted = true;
                break;
              case "rmeoteArea":
                this.deleteRemoteArea(this.data.id).then(() => {
                  this.$store.dispatch("sites/fetchSitesWithAreasAndKiosks");
                });
                // isDeleted = true;
                break;
              default:
                null;
            }
          }
        });
    },
  },
  beforeMount() {
    this.items = [];
    if (this.data.dataType == "kiosk") {
      this.kioskInfo = {
        mac_address: this.data.mac_address,
        kiosk_name: this.data.name,
      };
    }

    if (this.type == "site") {
      this.items.push(
        { visible: true, type: "site", text: this.$t('sitesAndDevices.siteActions.editSite'), modalId: "addSite_" },
        {
          visible: true,
          type: "site",
          text: this.$t('sitesAndDevices.siteActions.deleteSite'),
          modalId: "deleteSite",
          action: "delete",
          name: this.data.name,
          isBold: true,
          id: this.data.id,
        },
        {
          visible: true,
          type: "site",
          text: this.$t('sitesAndDevices.siteActions.addArea'),
          modalId: "addAreaFromSite_" + this.data.id + "ConfirmModal",
          isBold: true,
          areaMode: areaModes.NORMAL,
        },
        {
          visible: true,
          type: "site",
          text: this.$t('sitesAndDevices.siteActions.addRemoteArea'),
          modalId: "addAreaFromSite_" + this.data.id + "ConfirmModal",
          isBold: true,
          areaMode: areaModes.REMOTE,
        },
        {
          visible: true,
          type: "site",
          text: this.$t('sitesAndDevices.siteActions.kioskSettings'),
          modalId: "multipleKioskSettings_" + this.data.id,
          isBold: true,
        }
      );
    } else if (this.type == "area") {
      this.items.push(
        {
          visible: !this.data.loginMode.toLowerCase().includes("remote"),
          type: "area",
          text: this.$t("sitesAndDevices.areaActions.editArea"),
          modalId: "addAreaFromSite_" + this.data.id + "ConfirmModal",
          disabled:
            this.getPackageType == "Standalone" &&
            this.userEmail != "lt_techteam@visipoint.com",
          isEditMode: true,
          areaMode: areaModes.NORMAL,
        },
        {
          visible: this.data.loginMode.toLowerCase().includes("remote"),
          type: "area",
          text: this.$t("sitesAndDevices.areaActions.editArea"),
          modalId: "addAreaFromSite_" + this.data.id + "ConfirmModal",
          disabled:
            this.getPackageType == "Standalone" &&
            this.userEmail != "lt_techteam@visipoint.com",
          isEditMode: true,
          areaMode: areaModes.REMOTE,
        },
        {
          visible: !this.data.loginMode.toLowerCase().includes("remote"),
          type: "area",
          text: this.$t("sitesAndDevices.areaActions.moveArea"),
          modalId: "moveArea_" + this.data.id,
          disabled:
            this.getPackageType == "Standalone" &&
            this.userEmail != "lt_techteam@visipoint.com",
        },
        // {
        //   visible: !this.data.loginMode.toLowerCase().includes("remote"),
        //   type: "area",
        //   action: "download_exe",
        //   text: this.$t("sitesAndDevices.areaActions.downloadExe"),
        //   areaInfo : {id: this.data.id, name: this.data.name},
        //   disabled:
        //     this.getPackageType == "Standalone" &&
        //     this.userEmail != "lt_techteam@visipoint.com",
        // },
        {
          visible: true,
          type: "area",
          text: this.$t("sitesAndDevices.areaActions.deleteArea"),
          modalId: "deleteArea",
          action: "delete",
          name: this.data.name,
          isBold: !this.data.loginMode.toLowerCase().includes("remote"),
          id: this.data.id,
          disabled:
            this.getPackageType == "Standalone" &&
            this.userEmail != "lt_techteam@visipoint.com",
        },
        {
          visible: !this.data.loginMode.toLowerCase().includes("remote"),
          type: "area",
          text: this.$t("sitesAndDevices.areaActions.addKiosk"),
          modalId: "addKiosk_" + this.data.id,
          action: "setData",
          isBold: true,
        },
        {
          visible: !this.data.loginMode.toLowerCase().includes("remote"),
          type: "site",
          text: this.$t('sitesAndDevices.siteActions.kioskSettings'),
          modalId: "multipleKioskSettings_" + this.data.id,
          isBold: true,
          disabled:
            this.getPackageType == "Standalone" &&
            this.userEmail != "lt_techteam@visipoint.com",
        }
      );
    } else if (this.type == "kiosk") {
      this.items.push(
        { visible: true, type: "kiosk", text: this.$t("sitesAndDevices.kioskActions.openDoor"), actionType: "open_door" , name: this.data.name , mac_address:this.data.mac_address},
        {
          visible: true,
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.restartKiosk'),
          actionType: "restart_kiosk",
          name: this.data.name , 
          mac_address:this.data.mac_address
        },
        {
          visible: true,
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.restartApp'),
          actionType: "restart_app",
          name: this.data.name , 
          mac_address:this.data.mac_address
        },
        { visible: true, type: "kiosk", text: this.$t("sitesAndDevices.kioskActions.screenshot") },
        {
          visible: true,
          type: "kiosk",
          text: this.$t('sitesAndDevices.siteActions.kioskSettings'),
          modalId: "kioskSetting_" + this.data.id,
          disabled: this.getPackageType == "Standalone",
        },
        {
          visible: true,
          type: "kiosk",
          text: this.$t("sitesAndDevices.kioskActions.installApp"),
          modalId: "installApp_" + this.data.id,
        },
        {
          visible: true,
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.kioskInfo'),
          modalId: "kioskInfo_" + this.data.id,
        },
        {
          visible: true,
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.previewLogs'),
          mac_address: this.data.mac_address,
          id: this.data.id,
          name: this.data.name,
          modalId: "kioskLogs_" + this.data.id,
        },
        {
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.getLogs'),
          visible: this.userEmail == "lt_techteam@visipoint.com",
        },
        {
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.getDatabase'),
          id: "manual_pull_database",
          visible: this.userEmail == "lt_techteam@visipoint.com",
        },
        {
          type: "kiosk",
          visible: true,
          text: this.$t('sitesAndDevices.kioskActions.changeJourney'),
          modalId: "changeJourney_" + this.data.id,
        },
        {
          type: "kiosk",
          visible: true,
          text: this.$t('sitesAndDevices.kioskActions.moveKiosk'),
          modalId: "moveKiosk_" + this.data.id,
          disabled:
            this.getPackageType == "Standalone" &&
            this.userEmail != "lt_techteam@visipoint.com",
        },
        {
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.refreshFaceLibrary'),
          modalId: "refreshFaceLibrary_" + this.data.id,
          visible: this.userEmail == "lt_techteam@visipoint.com",
        },
        {
          type: "kiosk",
          text: this.$t('sitesAndDevices.kioskActions.remoteControl'),
          modalId: "remoteControl_" + this.data.id,
          visible: this.userEmail == "lt_techteam@visipoint.com",
          // name: this.data.name,
          // id: this.data.id,
        },
        {
          type: "kiosk",
          visible: true,
          text: this.$t('sitesAndDevices.kioskActions.deRegister'),
          action: "delete",
          name: this.data.name,
          id: this.data.id,
        }
      );
    }
  },
};
</script>
<style lang="scss">
.dropdown-wrapper {
  padding: 0;
  border-bottom: 1px solid #e9e9e9;
  .dropdown-items {
    font-weight: 400;
    font-size: 17.5px !important;
    text-align: center;
    line-height: 19px !important;
    color: #787878;
    margin: 12px auto !important;
  }
  .red-remove {
    color: #f46a6a !important;
  }
}
.bold-divider {
  border-bottom: 4px solid #e9e9e9 !important;
}
.dx-scrollview-content
  > .dx-item:last-of-type
  > .dropdown-wrapper:last-of-type {
  border: none !important;
}
.dx-scrollable-scroll,
.dx-scrollable-scroll-content {
  background: #666666 !important;
  border-radius: 8.5px !important;
}
.dx-scrollable-scrollbar.dx-widget.dx-scrollbar-vertical.dx-scrollbar-hoverable {
  background: #ededed !important;
  border-radius: 8.5px !important;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
}
</style>
